export default __webpack_public_path__ + "static/media/m_engineering_card02_1.18d42b04.png";